module.exports = __webpack_public_path__ + "img/card-bg-7.c9fbc687.jpg";